var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfiable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.33 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8c78e;}.cls-2{fill:#d1ab7d;}.cls-3{fill:#ba9670;}.cls-4{fill:#E30613;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "confiable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.05,18.6l6.41,2.24a7.28,7.28,0,0,0,5.66-.36L59.67,13.2a3.25,3.25,0,0,1,4,.88L71.52,24a.88.88,0,0,0,.25.22c2,1.25,24.26,15.58,36.83,30.42a3,3,0,0,1-.18,4.08l-4.71,3.61a3.78,3.78,0,0,1-2.46.77h0c1,1.56.58,1.94-.34,3A29,29,0,0,1,95,70.72c-1.18.66-3.78-.39-3.78-.39s.82.84.42,1.44c-.84,1.27-4.8,3.82-6.64,4.87a2.85,2.85,0,0,1-2.68-.11s.41,1.1-.25,1.6a20.39,20.39,0,0,1-5.38,3,5.27,5.27,0,0,1-3.42-.34,54.38,54.38,0,0,1-7.43-3.5L32.27,56.84a.87.87,0,0,1-.23-.19L20.6,43.6a1,1,0,0,1-.15-1.09l11.37-23.4A1,1,0,0,1,33.05,18.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.55,76.33l1.67-2,5.29,4.09a1.9,1.9,0,0,0,2.61-.29l1-1.27a1.58,1.58,0,0,0,.28.9c.27.38,4.45,2.9,4.45,2.9a2.44,2.44,0,0,0,3-1c2.13-3.24,5-8.33,5-8.33a3.1,3.1,0,0,0-.77-3.79s-2.72-2.84-3.93-3.27a1.07,1.07,0,0,0-.95.23l1.84-4.66a4.78,4.78,0,0,0-1.74-5.38l-3-2.15a1.64,1.64,0,0,0-2.29.39l-1.42,2V51.42a3.07,3.07,0,0,0-1.38-2.56L53,47.37a1.58,1.58,0,0,0-2,.24L47.78,51s-2.84-3.78-4.46-5.74a1.39,1.39,0,0,0-2.18,0L31.21,58a3,3,0,0,0-.06,3.63l4.23,5.79a2.55,2.55,0,0,0,1.47,1l.45.11-.09,1.84a2.59,2.59,0,0,0,.93,2.13L43,76.56A1.8,1.8,0,0,0,45.55,76.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.2,14.79l-9.13,3.1a10.67,10.67,0,0,1-6.88,0L66.24,10a1.78,1.78,0,0,0-2.07.7L52.7,27.92a1.38,1.38,0,0,0,.39,1.92c1.75,1.15,5.27,3,8.81,2.33a4.35,4.35,0,0,0,2.69-1.74L69,24.35s19.55,8.5,37.89,28.28L121.05,41.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.26,60c-2.67-.88-4.85-3.3-6.23-4.68C81.86,41.15,70.4,37.25,70.4,37.25c15.71,8.48,30.85,25.82,30.85,25.82h0a3.78,3.78,0,0,0,2.46-.77l4.71-3.61S105.09,61,102.26,60Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89,66.05c-9.44-9.92-15.36-13.76-15.36-13.76a166.93,166.93,0,0,1,17.61,18s2.6,1,3.78.39a28.51,28.51,0,0,0,3.43-2.39C98.17,68.5,94.18,71.55,89,66.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.56,74.85A42.09,42.09,0,0,0,73.7,68.5c3.67,2.44,8.6,8,8.6,8a2.85,2.85,0,0,0,2.68.11c.65-.37,1.57-.93,2.52-1.56C86.86,75.49,83.62,76.92,81.56,74.85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.87,49.82l-1.51-2a4.46,4.46,0,0,1,.38,3.33c-.58,2-6,8.84-8.06,11.41-1.89,2.38-.43,5.37-2,5.15a2.54,2.54,0,0,0,1.21.67l.45.11L38,64.9a2.37,2.37,0,0,1,.43-1L47.78,51Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.49,66.44l7.12-11.75V51.42a3.07,3.07,0,0,0-.67-1.9l-.16-.19h0A5.18,5.18,0,0,1,55.67,54c-1.89,3.73-7,11.23-9.33,14.7-1.07,1.63-.71,2.17-.91,5a7.19,7.19,0,0,1-.88,3.23,1.81,1.81,0,0,0,1-.6l1.67-2a12.28,12.28,0,0,1,.32-3.6A21.35,21.35,0,0,1,49.49,66.44Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.05,59.83a4.76,4.76,0,0,0-1.39-5.08c.09.22.67,1.89-.3,4.91C62.07,63.71,55.67,74,54.62,76.19s-2.51,1.91-2.51,1.91l.4.31a1.9,1.9,0,0,0,2.61-.29l1-1.27a63.46,63.46,0,0,1,3.1-6.41,49,49,0,0,1,4-6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.27,25.38c-4.12-1.51-2-5.87-2-5.87L69,24.35s19.55,8.5,37.89,28.28C91.75,34,78.09,26.77,74.27,25.38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.69,
    y: 15.77,
    width: 37.89,
    height: 22.89,
    rx: 1.83,
    ry: 1.83,
    transform: "translate(-13.06 29.57) rotate(-55.39)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.52,
    y: 12.76,
    width: 37.89,
    height: 22.89,
    rx: 1.83,
    ry: 1.83,
    transform: "translate(157.98 139.86) rotate(-119.87)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiable);
export default __webpack_public_path__ + "static/media/confiable.9a0908096b80516b57a65f7db66de831.svg";
export { ForwardRef as ReactComponent };